// External reference documents (Google Drive) linked from assessment data entry pages.
// If a file is moved or re-uploaded in Drive, its id changes and the link here must be updated.
export const BECK_T_SCORE_CHART_AGE_11_TO_14_URL =
  'https://drive.google.com/file/d/1BDFfCobjRYBAAbY_qPU1fmefs5FCR3WL/view?usp=sharing';
export const BECK_T_SCORE_CHART_AGE_15_TO_18_URL =
  'https://drive.google.com/file/d/1x5AOt2jk5ifaontsbUP4j1I1admNc2Zi/view?usp=sharing';
export const RSCA_SCORE_SHEET_URL =
  'https://drive.google.com/file/d/17mjih0i-eZkU1j91NXWe8VBNm_75xjFx/view?usp=drive_link';
